const publicationsLoadMore = () => {
  const btn = document.getElementById('load-more')

  const countHiddenPost = () => {
    return document.querySelectorAll('.publication__grid .publication-box.hidden')
  }

  if (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      const hiddenPost = countHiddenPost()
      let counter = 0

      hiddenPost.forEach((post) => {
        counter++

        if (counter <= 3) {
          post.classList.remove('hidden')
        } else {
          return false
        }

        if (countHiddenPost().length < 1) {
          btn.remove()
        }
      })
    })
  }
}

export default publicationsLoadMore
